import { sourceURL, pbSourceURL } from './baseURL'

export const userAvator = img => img ? `${sourceURL}/Image/${img}` : require('imgs/default-avator.png')

// export const imgPath = img => img && `${baseURL}/Images/${img}`

export const imgPath = img => {
  return img ? `${sourceURL}/Image/${img}` : require('imgs/modules/default-cover.webp')
}

export const filePath = file => {
  return file ? `${sourceURL}/Files/${file}` : ''
}

/* 智慧党建模块的图片 */
export const partyBuildingImgPath = img => {
  return img ? `${pbSourceURL}/Pimg/${img}` : require('imgs/modules/default-cover.webp')
}

/**
 * 页面背景/标题背景
 * @param {String} img
 * @returns String
 */
export const pageBgConfigure = img => {
  return img ? `${sourceURL}/PageBg/${img}` : ''
}

/**
 * @param {String} sysDate 系统时间("2021-06-28T10:56:11.117")
 * @return {String} yy-MM-dd
 */
export const timeCut = time => time ? time.substring(0, 10) : ''

/**
 * date formatting
 * {{ Date() | formatDate }} -> 2020-09-28 15:54:52
 * {{ '2020/10/01 12:30:45' | formatDate('yyyy-MM-dd hh:mm:ss w') }} -> 2020-10-01 12:30:45 星期四
 * @param {Date} value 可以被 new Date(value) 解析的时间格式，如 Date()、2020/10/01、2020-10-01 12:00 等
 * @param {String} fmt 格式化模版
 */
export const formatDate = (value, fmt = 'yyyy-MM-dd hh:mm') => {
  if (!value) {
    return ''
  } else {
    const date = new Date(value)
    const o = {
      'M+': date.getMonth() + 1, // month
      'd+': date.getDate(), // day
      'h+': date.getHours(), // hour
      'm+': date.getMinutes(), // minute
      's+': date.getSeconds(), // second
      'w+': date.getDay(), // week
      'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
      S: date.getMilliseconds() // millisecond
    }

    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }

    for (var k in o) {
      if (k === 'w+') {
        if (o[k] === 0) {
          fmt = fmt.replace('w', 'Sunday')
        } else if (o[k] === 1) {
          fmt = fmt.replace('w', 'Monday')
        } else if (o[k] === 2) {
          fmt = fmt.replace('w', 'Tuesday')
        } else if (o[k] === 3) {
          fmt = fmt.replace('w', 'Wednesday')
        } else if (o[k] === 4) {
          fmt = fmt.replace('w', 'Thursday')
        } else if (o[k] === 5) {
          fmt = fmt.replace('w', 'Friday')
        } else if (o[k] === 6) {
          fmt = fmt.replace('w', 'Saturday')
        }
      } else if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }

    return fmt
  }
}

export const textLenHandler = (text, len = 6, carry = 0) => {
  if (text) return text.length > len ? text.slice(0, len - carry) + '...' : text
}

/* 替换括号 */
export const filterText = text => text ? text.replace(/\([^\)]*\)/g, '') : ''

export const hiddenIDcard = IDcard => IDcard ? IDcard.replace(/^(.{4})(?:\d+)(.{4})$/, '$1******$2') : ''

export const hiddenPhone = phone => phone ? (phone.toString().replace(/(\d{3})(\d{4})(\d{4})/, '$1****$3')) : ''

/**
 * @description 姓名半隐藏
 * @param {string} str
 * @return string
 */
export const hiddenName = str => {
  if (str != null && str != undefined) {
    let star = ''
    if (str.length <= 2) {
      return str.substring(0, 1) + '*'
    } else {
      for (let i = 0; i < str.length - 2; i++) {
        star = star + '*'
      }
      return str.substring(0, 1) + star + str.substring(str.length - 1, str.length)
    }
  }
}

/**
 * @description 获取富文本的纯文字内容
 * @param {string} richCont
 * @param {string} noValtext
 * @returns string
 */
export const filtersRichtext = (richCont, noValtext = '') => {
  // 转意符换成普通字符
  function convertIdeogramToNormalCharacter(val) {
    const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"', 'ldquo': '“', 'rdquo': '”', 'mdash': '-' }
    return val.replace(/&(lt|gt|nbsp|amp|quot|ldquo|rdquo|mdash);/ig, function(all, t) { return arrEntities[t] })
  }
  // const str = richCont
  let value = richCont
  if (richCont) {
    // 方法一：
    value = value.replace(/\s*/g, '') // 去掉空格
    value = value.replace(/<[^>]+>/g, '') // 去掉所有的html标记
    value = value.replace(/↵/g, '') // 去掉所有的↵符号
    value = value.replace(/[\r\n]/g, '') // 去掉回车换行
    value = value.replace(/&nbsp;/g, '') // 去掉空格
    value = convertIdeogramToNormalCharacter(value)
    return value

    // 方法二：
    // value = value.replace(/(\n)/g, "");
    // value = value.replace(/(\t)/g, "");
    // value = value.replace(/(\r)/g, "");
    // value = value.replace(/<\/?[^>]*>/g, "");
    // value = value.replace(/\s*/g, "");
    // value = convertIdeogramToNormalCharacter(value);
    // return value;
  } else {
    return noValtext
  }
}

/**
 * 获取富文本图片
 * @param {str} richText
 * @returns Array
 */
export const getImgSrcArr = str => {
  if (!str) return [require('imgs/modules/default-cover.webp')]
  const imgList = []
  str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g, (match, capture) => {
    imgList.push(capture)
  })
  return imgList.length > 0 ? imgList : [require('imgs/modules/default-cover.webp')]
}

export const ms2seconds = ms => {
  if (ms) {
    const value = Number(ms) / 1000
    return Math.round(value / 60)
  } else return 0
}
